var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mt-5" },
    [
      _vm.error
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-around": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm8: "", md7: "", lg5: "", xl4: "" } },
                [
                  _c("app-alert", {
                    attrs: { text: _vm.error.message, id: "signin_error" },
                    on: { dismissed: _vm.onDismissed }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-around": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm8: "", md7: "", lg5: "", xl4: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.onFormSubmitted.apply(
                                    null,
                                    arguments
                                  )
                                }
                              },
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-icon": "mail",
                                          label: _vm.$t("email"),
                                          name: "email",
                                          id: "email",
                                          type: "email",
                                          disabled: _vm.userLoading
                                        },
                                        model: {
                                          value: _vm.email,
                                          callback: function($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-icon": "lock",
                                          label: _vm.$t("password"),
                                          name: "password",
                                          id: "password",
                                          type: "password",
                                          disabled: _vm.userLoading
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { "align-baseline": "", wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xl4: "" } }),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm8: "", xl5: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { staticClass: "text-xs-right" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "linkText",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showSuggestionDialog.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("contactUs"))
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { staticClass: "text-xs-right" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "linkText",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showResetPasswordEmailDialog.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("forgotPassword")
                                                    ) + "?"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { staticClass: "text-xs-right" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            type: "submit",
                                            id: "submitSignin",
                                            loading: _vm.userLoading,
                                            disabled:
                                              _vm.userLoading || !_vm.canSignin
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("signIn")) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ResetPasswordEmailPopup", {
        model: {
          value: _vm.resetPasswordEmailDialog,
          callback: function($$v) {
            _vm.resetPasswordEmailDialog = $$v
          },
          expression: "resetPasswordEmailDialog"
        }
      }),
      _vm._v(" "),
      _vm.suggestionDialog
        ? _c("SuggestionsPopup", {
            attrs: { actionMethod: _vm.SubmitSuggestion },
            scopedSlots: _vm._u(
              [
                {
                  key: "inputText",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        [
                          _c("v-flex", [
                            _vm._v(
                              _vm._s(_vm.$t("suggestionsOrQuestions")) + " "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.$t("profileContact")) + "\n        "
                          ),
                          _c("br"),
                          _vm._v("QQ: 3372450933\n        "),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(_vm._s(_vm.$t("or")) + "\n        "),
                          _c("br"),
                          _vm._v(" "),
                          _c("br")
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              607877703
            ),
            model: {
              value: _vm.suggestionDialog,
              callback: function($$v) {
                _vm.suggestionDialog = $$v
              },
              expression: "suggestionDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e11165c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e11165c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signin.vue
// module id = null
// module chunks = 